import * as Yup from 'yup';
import { UFormGovAgenda } from '../../models';

export function useValidationSchema() {
  return Yup.object<UFormGovAgenda>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    externalId: Yup.string().optional(),
    description: Yup.string().optional(),
  });
}
